<div class="order-edit-dialog">
  <app-patient-order-details
    [embedded]="true"
    [embedPatientId]="data.patientId"
    [embedOrderId]="data.orderId"
    (closeEmbed)="onClose($event)"
  ></app-patient-order-details>
</div>
